import { useRef } from "react";
import { useLocation } from "react-router-dom";
import traceUFOPageLoad from "@atlaskit/react-ufo/trace-pageload";
import traceUFOTransition from "@atlaskit/react-ufo/trace-transition";
import { RouteSLOKeys } from "../../observability/config";

/**
 * **Important**: This variable definition is read by the observability pipeline step for the purpose of automatically
 * setting up service level objectives (SLOs) for selected routes. If you want to create an SLO for your route, provide
 * a RouteSLOKey for its UFO name below, otherwise use a regular string. If you need to rename this variable or move its
 * definition into another file for some reason, update the `ROUTE_DEFINITION_VARIABLE` and `ROUTE_DEFINITION_FILE` in
 * the file `afm/rovo-extension/operations/scripts/constants.ts` accordingly.
 */
const ufoRouteNameByPath: Readonly<Record<string, string | undefined>> = {
  "/extension": RouteSLOKeys.HOME,
  "/extension/login-redirect": "login-redirect",
  "/extension/log-out": "logout",
  "/extension/menu": "menu",
  "/extension/ntp-login-redirect": RouteSLOKeys.NTP_LOGIN_REDIRECT,
  "/extension/ntp-logout-redirect": "ntp-logout-redirect",
  "/extension/options": RouteSLOKeys.OPTIONS,
  "/extension/popup": RouteSLOKeys.POPUP,
  "/extension/rovo-chat": RouteSLOKeys.CHAT,
  "/extension/session": "session",
  "/extension/uninstall": RouteSLOKeys.UNINSTALL,
  "/extension/welcome": RouteSLOKeys.WELCOME,
};

export function useReactUFORouteWatcher(): void {
  const location = useLocation();
  const isFirstRender = useRef<boolean>(true);
  const pathname = useRef<string>("");

  if (pathname.current !== location.pathname) {
    pathname.current = location.pathname;

    // do not emit UFO events for any undefined experiences
    const ufoName: string | undefined = ufoRouteNameByPath[location.pathname];
    if (ufoName) {
      if (isFirstRender.current) {
        traceUFOPageLoad(ufoName);
        isFirstRender.current = false;
      } else {
        traceUFOTransition(ufoName);
      }
    }
  }
}
